// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/EventInfo/styles.css
// module id = 428
// module chunks = 0